import moment from "moment"
import { Base64 } from 'js-base64';

export default {
    /**
     * changeURLStatic 修改地址栏 URL参数 不跳转
     * @param name
     * @param value
     */
    changeURLStatic: function (name, value) {
        let url = this.changeURLParam(location.href, name, value); // 修改 URL 参数
        history.replaceState(null, null, url);  // 替换地址栏
    },


    /**
     * changeURLParam 修改 URL 参数
     * @param url
     * @param name
     * @param value
     * @returns {string}
     */
    changeURLParam: function (url, name, value) {
        if (typeof value === 'string') {
            value = value.toString().replace(/(^\s*)|(\s*$)/, ""); // 移除首尾空格
        }
        let url2;
        if (!value) { // remove
            let reg = eval('/(([?|&])' + name + '=[^&]*)(&)?/i');
            let res = url.match(reg);
            if (res) {
                if (res[2] && res[2] === '?') { // before has ?
                    if (res[3]) { // after has &
                        url2 = url.replace(reg, '?');
                    } else {
                        url2 = url.replace(reg, '');
                    }
                } else {
                    url2 = url.replace(reg, '$3');
                }
            }
        } else {
            let reg = eval('/([?|&]' + name + '=)[^&]*/i');
            if (url.match(reg)) { // edit
                url2 = url.replace(reg, '$1' + value);
            } else { // add
                let reg = /([?](\w+=?)?)[^&]*/i;
                let res = url.match(reg);
                url2 = url;
                if (res) {
                    if (res[0] !== '?') {
                        url2 += '&';
                    }
                } else {
                    url2 += '?';
                }
                url2 += name + '=' + value;
            }
        }
        return url2;
    },

    mergeArray: function (arr1, arr2) {
        var _arr = new Array();
        for (let i = 0; i < arr1.length; i++) {
            _arr.push(arr1[i]);
        }
        for (let i = 0; i < arr2.length; i++) {
            var flag = true;
            for (let j = 0; j < arr1.length; j++) {
                if (arr2[i] == arr1[j]) {
                    flag = false;
                    break;
                }
            }
            if (flag) {
                _arr.push(arr2[i]);
            }
        }
        return _arr;
    },
    formatSize: function (value) {
        if (!value || null == value || value == "") {
            return "0 B";
        }
        var unitArr = new Array(
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        );
        var index = 0,
            srcsize = parseFloat(value);
        index = Math.floor(Math.log(srcsize) / Math.log(1024));
        var size = srcsize / Math.pow(1024, index);
        //  保留的小数位数
        size = size.toFixed(2);
        return size + " " + unitArr[index];
    },
    formatTime: function (time) {
        if (!time) {
            return "00:00:00";
        }
        let min = Math.floor(time % 3600);
        let val =
            this.formatTimeBit(Math.floor(time / 3600)) +
            ":" +
            this.formatTimeBit(Math.floor(min / 60)) +
            ":" +
            this.formatTimeBit(time % 60);
        return val;
    },
    formatTimeBit: function (val) {
        val = +val;
        return val > 9 ? val : "0" + val;
    },
    formatDate: function (value) {
        return moment(value).format("YYYY-MM-DD HH:mm:ss");
    },
    getInfoFromPid: function (pid) {
        let data = {
            cid: null,
            did: null
        }
        if (pid.length > 6) {
            data.cid = parseInt(pid.substr(-6, 2), 16);
            data.did = parseInt(pid.substr(-4, 2), 16);
        }
        return data
    },
    buildUint8Array: function (ids) {
        ids = ids.sort(function (a, b) {
            return a - b;
        });
        console.log(ids);
        if (ids.length <= 0) {
            return {
                ids: new Uint8Array(),
                start: 0,
                len: 0
            };
        }
        let start = ids[0];
        let end = ids[ids.length - 1]
        let len = end - start + 1;
        let bitArray = [];
        let bit8Array = [];
        for (let index = start; index <= end; index++) {
            if (ids.includes(index)) {
                bitArray.push(1);
            } else {
                bitArray.push(0);
            }
            if (bitArray.length >= 8) {
                bit8Array.push(bitArray);
                bitArray = [];
            }
        }
        if (bitArray.length > 0) {
            for (let index = bitArray.length; index < 8; index++) {
                bitArray[index] = 0;
            }
            bit8Array.push(bitArray);
            bitArray = [];
        }
        console.log(bit8Array);
        let uint8Array = new Uint8Array(bit8Array.length);
        for (let index = 0; index < bit8Array.length; index++) {
            const bit8Item = bit8Array[index];
            let bitInt = parseInt(bit8Item.join(""), 2);
            uint8Array[index] = bitInt;
        }
        return {
            ids: uint8Array,
            start: start,
            len: len
        };
    },
    isLargeVersion: function (curV, reqV) {
        if (curV && reqV) {
            //将两个版本号拆成数字
            var arr1 = curV.split('.'),
                arr2 = reqV.split('.');
            var minLength = Math.min(arr1.length, arr2.length),
                position = 0,
                diff = 0;
            //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
            while (position < minLength && ((diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0)) {
                position++;
            }
            diff = (diff != 0) ? diff : (arr1.length - arr2.length);
            //若curV大于reqV，则返回true
            return diff > 0;
        } else {
            //输入为空
            console.log("版本号不能为空");
            return false;
        }
    },
    getDownloadUrlType: function (url) {
        let splitArray = url.split("://");
        let preType = splitArray[0];
        if (preType) {
            return preType;
        }
        splitArray = url.split(":");
        preType = splitArray[0];
        if (preType) {
            return preType;
        }
        return "";
    },
    getThunderSourceUrl: function (tUrl) {
        let splitArray = tUrl.split("://");
        let preType = splitArray[0];
        if (preType == "thunder" && splitArray.length > 0) {
            let sUrl = splitArray[1];
            let dUrl = Base64.decode(sUrl);
            // console.log(dUrl);
            dUrl = dUrl.substring(2, dUrl.length);
            // console.log(dUrl);
            dUrl = dUrl.substring(0, dUrl.length - 2);
            // console.log(dUrl);
            return dUrl;
        } else {
            return "";
        }
    },
    getTaskInfo: function (taskId) {
        let key = "task:" + taskId;
        let taskInfo = localStorage.getItem(key);
        taskInfo = JSON.parse(taskInfo);
        return taskInfo;
    },
    setTaskInfo: function (taskId, taskInfo) {
        let key = "task:" + taskId;
        let info = JSON.stringify(taskInfo);
        localStorage.setItem(key, info);
    },
    delTaskInfo: function (taskId) {
        let key = "task:" + taskId;
        localStorage.removeItem(key);
    }
}